import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
	downloadRegCard,
	emailSendRegCard,
	getOnboardingStatus,
	getProfile,
	getProfilesFromReservation,
	getProfileUdfs,
	getRetryStatus,
	getVicasQueueStatus,
	updateGuestProfile,
	updateSingleProfilDetail,
	UpdateStatusAndRetry,
} from '../api';

import { display } from './sessionSlice';
import type { RootState } from './../store';

export const updateProfile1 = createAsyncThunk<
	boolean,
	{
		transactionGUID: string;
		token: string;
		profileID: number;
		pmsProfileID: string;
		reservationID: number;
		pmsConfirmationNo: string;
		isPrimary: boolean;
		firstName: string;
		lastName: string;
		addressLine1: string;
		// documentNumber: string;
		//   documentType: string;
		// nationality: number;
		// nationalityCountry: string;
		// issueDate: string;
		// expiryDate: string;
		countryOfResidence: number;
		email: string;
		phoneNo_Res: string;
		propertyCode: string;

		vehiclePlateNo: string;
		postalCode: string;
		permitNo: string;
		euPlaceOfEntry: string;
		euDateOfEntry: Date;
		city: string;
		dateofBirthDT: string;
		dateOfBirth: string;
		issuePlace: string;

		udfFields: {
			udfCode: string;
			udfProfileValue: string;
		}[];
		profileDocuments: any[];
	}
>('Document/UpdateProfileDetails', async (profileParam, _thunkAPI) => {
	const response = await updateGuestProfile(profileParam);
	return response?.data?.result;
});
export const updateProfile = createAsyncThunk<
	boolean,
	{
		dto: any;
	}
>('Document/UpdateProfileDetails', async (profileParam, _thunkAPI) => {
	/* eslint-disable no-debugger */
	//debugger;
	/* eslint-enable no-debugger */
	const response = await updateGuestProfile(profileParam.dto);
	return response?.data?.result;
});

export const getVicasQueueStatusCall = createAsyncThunk<
	any,
	{ token: any; sessionToken: any; profileID: any }
>('Profile/GetVicasQueueStatus', async (param, _thunkAPI) => {
	/* eslint-disable no-debugger */
	//debugger;
	/* eslint-enable no-debugger */
	const response = await getVicasQueueStatus({
		token: param.token,
		profileID: param.profileID,
		sessionToken: param.sessionToken,
	});
	return response?.data;
});

export const updateSingleProfile = createAsyncThunk<
	boolean,
	{
		token: any;
		sessionToken: any;
		dto: any;
	}
>('Document/UpdateSingleProfilDetail', async (profileParam, _thunkAPI) => {
	/* eslint-disable no-debugger */
	//debugger;
	/* eslint-enable no-debugger */
	const response = await updateSingleProfilDetail({
		token: profileParam.token,
		sessionToken: profileParam.sessionToken,
		profile: profileParam.dto,
	});
	return response?.data;
});

export const updateRetryCount = createAsyncThunk<
	any,
	{
		token: any;
		sessionToken: any;
		dto: any;
		type: string;
	}
>('Document/UpdateStatusAndRetry', async (profileParam, _thunkAPI) => {
	/* eslint-disable no-debugger */
	//debugger;
	/* eslint-enable no-debugger */
	const response = await UpdateStatusAndRetry({
		token: profileParam.token,
		sessionToken: profileParam.sessionToken,
		profile: profileParam.dto,
		type: profileParam.type,
	});
	return response?.data;
});

export const fetchRetryStatus = createAsyncThunk<
	object,
	{ token: any; sessionToken: any; profileID: any }
>('Profile/GetRetryStatus', async (param, _thunkAPI) => {
	const retryStatus = await getRetryStatus({
		token: param.token,
		magicToken: param.sessionToken,
		profileID: param.profileID,
	});
	return retryStatus?.data;
});

export const fetchProfile = createAsyncThunk<
	object,
	{ profiles: object[]; profileID: number }
>('Profile/FetchProfile', async (param, _thunkAPI) => {
	const mainProfile = param.profiles.find((profile: any) => {
		return profile.profileID === param.profileID;
	});
	return mainProfile;
});

export const updateProfileID = createAsyncThunk<object, { profileID: any }>(
	'Profile/UpdateProfileID',
	async (param, _thunkAPI) => {
		return param?.profileID;
	}
);
export const fetchProfileUDF = createAsyncThunk<any, { profileID: number }>(
	'Profile/FetchProfileUDF',
	async (param, _thunkAPI) => {
		const response = await getProfileUdfs(param.profileID);
		return response?.data;
	}
);

export const fetchSingleProfile = createAsyncThunk<
	any,
	{ token: string; confirmationNo: string; profileId: number }
>('Profile/FetchSingleProfile', async (param, _thunkAPI) => {
	const response = await getProfile(
		param.token,
		param.confirmationNo,
		param.profileId
	);
	return response?.data?.data ?? response?.data;
});

export const sendRegistrationCard = createAsyncThunk<
	any,
	{
		token: string;
		email: string;
	}
>('Profile/SendRegistrationCard', async (param, thunkAPI) => {
	try {
		const response = await emailSendRegCard({
			token: param.token,
			email: param.email,
		});
		return response?.data;
	} catch (error: any) {
		return thunkAPI.rejectWithValue(
			error.response?.data?.message ||
				error.message ||
				'Failed to send registration card'
		);
	}
});

export const downloadRegistrationCard = createAsyncThunk<
	void,
	{ token: string }
>('Profile/DownloadRegistrationCard', async (param, thunkAPI) => {
	try {
		const response = await downloadRegCard({
			token: param.token,
		});

		// Convert to blob
		const blob = new Blob([response.data], { type: 'application/pdf' });

		// Create download link
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', 'RegCard.pdf');

		document.body.appendChild(link);
		link.click();
		link.remove();

		window.URL.revokeObjectURL(url);
	} catch (error: any) {
		return thunkAPI.rejectWithValue(
			error.response?.data?.message ||
				error.message ||
				'Failed to download registration card'
		);
	}
});

export const fetchOnboardingStatus = createAsyncThunk(
	'Onboarding/FetchStatus',
	async (
		{ token, sessionToken }: { token: string; sessionToken: string },
		thunkAPI
	) => {
		try {
			const response = await getOnboardingStatus(token, sessionToken);
			return response.data.Result;
		} catch (error: any) {
			return thunkAPI.rejectWithValue(
				error.response?.data?.message || error.message
			);
		}
	}
);

const initialState = {
	profile: null,
	currentProfile: null,
	error: {
		updateProfile: null,
		fetchProfile: null,
		sendRegCard: null,
	},
	profileID: null,
	isPostComplete: false,
} as any;

const profileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {
		clear: (state) => {
			state.profile = null;
			state.profileID = null;
		},
		resetPostComplete: (state) => {
			state.isPostComplete = false;
		},
		setProfileID: (state, action) => {
			state.profile.profileID = action?.payload;
		},
		setCurrentProfile: (state, action) => {
			state.currentProfile = action?.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(updateProfile.fulfilled, (state, action) => {
			state.profile = null;
			state.error.updateProfile = null;
			state.isPostComplete = true;
		});

		builder.addCase(updateProfile.rejected, (state, action) => {
			state.error.updateProfile = action?.error;
		});

		builder.addCase(fetchProfile.fulfilled, (state, action) => {
			state.profile = action?.payload;
			state.error.fetchProfile = null;
			if (state.profile === undefined) {
				state.error.fetchProfile = 'Profile not found';
			}
		});

		builder.addCase(fetchProfile.rejected, (state, action) => {
			state.error.fetchProfile = action?.error;
		});

		builder.addCase(updateProfileID.fulfilled, (state, action) => {
			state.profileID = action?.payload;
		});
		builder.addCase(fetchSingleProfile.fulfilled, (state, action) => {
			state.currentProfile = action?.payload;
		});

		builder.addCase(sendRegistrationCard.fulfilled, (state, action) => {
			state.error.sendRegCard = null;
		});

		builder.addCase(sendRegistrationCard.rejected, (state, action) => {
			state.error.sendRegCard = action.payload || action.error;
		});
	},
});

export const selectProfile = (state: RootState) => state.profile;
export const { clear, resetPostComplete, setProfileID, setCurrentProfile } =
	profileSlice.actions;
export default profileSlice.reducer;
